export const countries = [
  "Accounting/Finance",
  "Administrative/Clerical",
  "Advertising/Marketing",
  "Agriculture/Forestry/Fishing",
  "Architecture/Design",
  "Arts/Entertainment/Publishing",
  "Automotive",
  "Banking/Loans",
  "Beauty/Fashion",
  "Business Development",
  "Construction/Facilities",
  "Customer Service",
  "Education/Training",
  "Engineering/Architecture",
  "Government/Military",
  "Healthcare",
  "Hospitality/Travel",
  "Human Resources",
  "Information Technology",
  "Insurance",
  "Legal",
  "Management",
  "Manufacturing/Operations",
  "Media/Communications",
  "Nonprofit/Social Services",
  "Oil/Energy",
  "Real Estate",
  "Retail",
  "Sales",
  "Science/Biotech",
  "Telecommunications",
];
